import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Rating } from 'react-simple-star-rating'
import clsx from 'clsx'
import { Image } from '@/components/atoms/Image/Image'
import { MarketLogoProps } from '@/components/molecules/MarketplaceLogo/types'

export function MarketplaceLogo({ image, rating = 5, logoClassname, color = false }: MarketLogoProps) {
  return (
    <div className="relative flex flex-col items-center justify-center">
      <Image
        fixed={false}
        fluid
        data={image}
        height={24}
        width={150}
        className={clsx('w-full', !color && 'filter grayscale', logoClassname)}
      />
      <Rating
        initialValue={rating}
        iconsCount={5}
        SVGclassName="inline-block"
        readonly
        size={18}
        allowFraction
        SVGstorkeWidth={1}
        SVGstrokeColor="#FE8620"
        fillColor="#FE8620"
        emptyColor="rgba(255,255,255,0)"
        fillClassName="hidden"
      />
    </div>
  )
}
